import ChatPost from '../../../pages/Post/ChatPost/ChatPost'
import { ModalComponent } from '../ModalComponent/ModalComponent';
import './ModalPostChat.scss'

const ModalPostChat = ({
    setIsModal,
    selectedPostContent,
    setSelectedPostContent
}) => {
    return (
        <ModalComponent
            title='Просмотр поста'
            onClose={e => {
                setSelectedPostContent(null)
                setIsModal(false)
            }}
            style={{
                height: 'auto',
                maxWidth: '800px'
            }}
            child={
                <div className="modal-post">
                    {selectedPostContent &&
                        <ChatPost
                            post={selectedPostContent}
                            loading={false}
                            placeholderText="Пост не выбран"
                        />}
                </div>
            }
        />
    )
}

export default ModalPostChat